module.exports = __webpack_public_path__ + "static/media/cost.d02d9113.svg";